interface GetGuideTaglineProps {
  isGroupFacilitator?: boolean;
  tagline?: string | null;
}

export const getGuideTagline = ({ isGroupFacilitator, tagline }: GetGuideTaglineProps): string => {
  if (isGroupFacilitator) {
    return 'Professional Facilitator';
  }
  return tagline || 'Guide';
};

export const isRoomLive = (nextStart: number | undefined): boolean => {
  const now = Date.now();
  return !!nextStart && now > nextStart;
};
